import React, { useEffect, useState } from "react";
import { Container, Row, Col, CardBody, Button, Card } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast } from "react-toastify";
import avatar from "../../../assets/images/nav4.svg";
import { useSelector } from "react-redux";

export default function StaffDetail() {
  document.title = "Staff Detail | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();
  const staffId = location.state?.staffData?.data?.id;

  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { appRole, userPermissions } = useSelector(
    (state) => state.auth.currentUser
  );
  // Fetch staff details
  const fetchStaff = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.staff}/${id}`);
      setStaffData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching staff data:", error);
      toast.error("Failed to fetch staff details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (staffId) fetchStaff(staffId);
  }, [staffId]);

  const handleEditStaff = (staffId, gymId) => {
    navigate(`/add-staff?staffId=${staffId}&gymId=${gymId}`);
  };

  if (loading) {
    return (
      <p className=" text-center ff-sora fw-bold font-size-16">Loading...</p>
    );
  }

  if (!staffData) {
    return <p>No staff data found.</p>;
  }
  const formatPermissionName = (permission) => {
    return permission
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <Card className="rounded-4 ms-2 me-2 mb-2" style={{ minHeight: "550px" }}>
      <CardBody>
        <Row className="">
          <Col xs="12">
            <h2 className="card-title fw-bold ff-sora font-size-20 primary-black">
              Staff Detail
            </h2>
            <span className="ff-sora secondary-black fw-normal font-size-16">
              Profile Media
            </span>
          </Col>
        </Row>

        <Row className="g-0">
          <Col xs="12" className="mb-3">
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={
                  staffData?.additionalInfo?.profileImage == null
                    ? avatar
                    : `${process.env.REACT_APP_IMG_URL}${staffData?.additionalInfo?.profileImage}`
                }
                alt={`Profile`}
                className="object-fit-cover rounded-circle"
                height={160}
                width={160}
              />
            </div>
          </Col>
        </Row>

        <Row className="g-0">
          <div>
            <h6 className="fw-normal secondary-black font-size-16 mb-3 ff-sora">
              General Info
            </h6>
            <Row className="align-items-start g-0">
              <Col
                xs="5"
                className="light-black font-size-16 ff-sora fw-normal"
              >
                <p>Name</p>
                <p>Email</p>
                <p>Phone No.</p>
                <p>User Role</p>
                <p>Permissions</p>
              </Col>
              <Col
                xs="6"
                className="secondary-black font-size-16 ff-sora fw-normal"
              >
                <p>{staffData.firstName || "N/A"}</p>
                <p className="email-ellipsis">{staffData.email || "N/A"}</p>
                <p>{staffData.phoneNumber || "N/A"}</p>
                <p>{staffData.userRole || "N/A"}</p>
                <td>
                  <div className=" d-flex flex-wrap gap-2">
                    {Object.entries(staffData?.userPermissions || {})
                      .filter(([key]) => key !== "selected")
                      .flatMap(([category, permissions]) =>
                        Object.entries(permissions)
                          .filter(([key]) => key !== "selected")
                          .slice(0, 4)
                          .map(([permissionName], permissionIndex) => (
                            <span
                              key={`${category}-${permissionIndex}`}
                              className="badge bg-light font-size-14 fw-normal ff-sora rounded-5 px-2 py-2"
                              style={{ height: "30px" }}
                            >
                              {formatPermissionName(permissionName)}
                            </span>
                          ))
                      )}
                  </div>
                </td>
              </Col>
            </Row>
          </div>
        </Row>

        <Row className="g-0">
          <Col xs="12" className="mt-3 text-end mb-2">
            {userPermissions?.staff?.["Update Staff"] && (
              <Button
                className="rounded-pill"
                onClick={() => handleEditStaff(staffData.id, staffData.gymId)}
              >
                Edit Staff
              </Button>
            )}
          </Col>
        </Row>
      </CardBody>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "25px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </Card>
  );
}
